import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { navContextSearchSchema } from '~/features/catalog-v2/utils/nav-context';

const RunRecoveryPage = lazy(() => import('~/features/catalog-v2/pages/run-recovery-page'));

/** `from`/`back` (S12) — the failure-patterns view's "Fix & retry" lands here directly. */
const searchSchema = z.object({ ...navContextSearchSchema });

export const Route = createFileRoute('/_authenticated/_tenant/catalog-v2/runs/$runId/recovery')({
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { runId } = Route.useParams();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <RunRecoveryPage runId={runId} />
    </Suspense>
  );
}
